module.exports = __webpack_public_path__ + "static/media/pianohowto2.7e07fd6b.png";